import styled from "styled-components/macro";
import { Select } from "@gcs/design-system/react";

export const CompanySelect = styled(Select)(({ theme }) => ({
  maxWidth: "400px",
  paddingBottom: "32px",
  div: {
    background: theme.color.neutral["08"],
    color: theme.color.neutral["03"],
  },
  svg: {
    color: theme.color.neutral["03"],
  },
  label: {
    fontSize: "16px",
    [theme.breakpoint.md()]: {
      fontSize: "18px",
    },
  },
  input: {
    fontSize: "16px",
    [theme.breakpoint.md()]: {
      fontSize: "18px",
    },
  },
}));

export const Item = styled(Select.Item)(({ theme }) => ({
  zIndex: 9999,
  color: theme.color.neutral["03"],
  fontSize: "16px",
  [theme.breakpoint.md()]: {
    fontSize: "18px",
  },
}));

export const SelectContainer = styled.div(({ theme, disabled }) => ({
  pointerEvents: disabled ? 'none' : 'default',
  ">div>div": {
    background: disabled ? theme.color.neutral["06"] : theme.color.neutral["08"]
  }
}));
